import { useQuery } from "@tanstack/react-query";
import { fetchFloorPlans } from "~/_legacy/apis/fetch-floor-plans";

export const FLOOR_PLANS_BY_BRANCH_QUERY_KEY = "floorPlansByBranch";

export function useGetFloorPlansByBranch({
  branchUid,
  branchVersionId,
  shouldFetch = true,
}: {
  branchUid?: string;
  branchVersionId?: number;
  shouldFetch?: boolean;
}) {
  return useQuery({
    queryKey: [FLOOR_PLANS_BY_BRANCH_QUERY_KEY, branchUid, branchVersionId],
    queryFn: () => fetchFloorPlans({ branchUid: branchUid!, branchVersionId }),
    enabled: Boolean(branchUid) && shouldFetch,
  });
}
